import React from "react"
const Anonymous = ({style = {}, size = "36", className = "", fill="#4E525F", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="m30.206 20.977-2.542-1.351a6.978 6.978 0 0 0-3.148-.737h-1.695c-.12 0-.363.123-.363.246L19.19 29.7l-.242-4.3h-2.785l-.242 4.3-3.268-10.565c0-.123-.242-.246-.363-.246h-1.695c-1.09 0-2.18.246-3.148.737l-2.542 1.351C3.09 21.96 2 23.803 2 25.892v4.3C2 32.28 3.695 34 5.753 34h23.605c2.058 0 3.753-1.72 3.753-3.808v-4.3c0-2.089-1.09-3.932-2.905-4.915Z"
        />
        <path
            fill={fill}
            d="M15.924 19.778c-.45 0-.675.569-.562.995l.675 2.134c.112.284.337.426.562.426h1.913c.225 0 .45-.142.562-.426l.675-2.134c.113-.426-.112-.995-.562-.995h-3.263ZM16.433 6.606C16.915 6.242 17.397 6 18 6c.723 0 1.326.242 1.687.606.362.364.603.97.603 1.818 0 .485-.12.849-.361 1.212-.242.364-.483.728-.844 1.213l-1.206 1.212c-.602.485-1.084 1.09-1.325 1.575a5.375 5.375 0 0 0-.723 1.94c-.121.727-.242 1.454-.242 2.424h4.219c0-.849.12-1.454.361-2.06.242-.607.603-1.091 1.206-1.576.723-.606 1.326-1.213 1.928-1.819.603-.606 1.085-1.212 1.326-1.939.362-.727.482-1.454.482-2.424 0-1.94-.602-3.515-1.928-4.606C21.977 2.485 20.169 2 18 2c-1.326 0-2.531.242-3.616.727a6.16 6.16 0 0 0-2.53 2.06c-.603.97-.965 2.183-.965 3.637h4.821c0-.727.241-1.454.723-1.818Z"
        />
    </svg>
)
export default Anonymous